import { Component, OnInit } from '@angular/core';
import { DocumentService } from 'src/app/services/document.service';

@Component({
  selector: 'app-document-view',
  templateUrl: './document-view.component.html',
  styleUrls: ['./document-view.component.scss'],
})
export class DocumentViewComponent implements OnInit {
  public QuillConfiguration = {};
  public document: any = {};
  public title: any;
  public keywords: any;
  public summary: any;
  public showcase: any;
  public country: any;
  public city: any;
  public zipCode: any;
  public cityPopulation: any;
  public durationFrom: any;
  public durationTo: any;
  public type: any;
  public overview: any;
  public multiObjective: any;
  public implementations: any;
  public others: any;
  public references: any;
  public editorContent: any;

  constructor(private doc: DocumentService) { }

  ngOnInit() {
    this.document = this.doc.data;
    this.title = this.document.title ? this.document.title : '';
    this.keywords = this.document.keywords ? this.document.keywords : '';
    this.summary = this.document.summary ? this.document.summary : '';
    this.showcase = this.document.showcase ? this.document.showcase : '';
    this.country = this.document.country ? this.document.country : '';
    this.city = this.document.city ? this.document.city : '';
    this.zipCode = this.document.zipCode ? this.document.zipCode : '';
    this.cityPopulation = this.document.cityPopulation ? this.document.cityPopulation : '';
    this.durationFrom = this.document.yearFrom ? this.document.yearFrom : '';
    this.durationTo = this.document.yearTo ? this.document.yearTo : '';
    this.type = this.document.type ? this.document.type : '';
    this.overview = this.document.overview ? this.document.overview : '';
    this.multiObjective = this.document.multiObjectiveApproachSections;
    this.implementations = this.document.implementationActivitySections;
    this.others = this.document.otherSections;
    this.references = [];
    this.document.references.forEach(ref => {
      const links = ref.split(',').map(link => link.trim());
      links.forEach(link => {
        const hasProtocol = link.startsWith('http://') || link.startsWith('https://');
        this.references.push(hasProtocol ? link : `https://${link}`);
      });
    });
  }

  onEditorCreated(event) {
    const selection = event.getSelection(true);
    event.root.innerHTML(selection.index, this.summary);
  }
}